import React from "react";
import { Modal, Button, Table } from "react-bootstrap";
import { MecordColors } from "Constants/Color";
import {
  filterPopoverStyles,
  tableStyles,
} from "Constants/Style";
import { formatIndianAmount } from "helpers/formatIndianAmount";
import { AccessoryItem } from "./ServiceAccessoryRow";

interface ViewServiceAccessoriesModalProps {
  show: boolean;
  onHide: () => void;
  serviceName: string;
  serviceCategory: string;
  accessories: AccessoryItem[];
  currencySymbol?: string;
}

const ViewServiceAccessoriesModal: React.FC<ViewServiceAccessoriesModalProps> = ({
  show,
  onHide,
  serviceName,
  serviceCategory,
  accessories,
  currencySymbol = "₹",
}) => {
  const serviceLabel = serviceName || serviceCategory || "Service";

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="custom-wide-modal"
    >
      <style>
        {`
          .custom-wide-modal {
            max-width: 80% !important;
            width: 80% !important;
          }
        `}
      </style>
      <Modal.Header
        closeButton
        style={{
          fontFamily: tableStyles.header.fontFamily,
          fontSize: tableStyles.header.fontSize,
          borderBottom: "1px solid #dee2e6",
        }}
      >
        <Modal.Title
          style={{
            fontFamily: tableStyles.header.fontFamily,
            fontSize: "15px",
            fontWeight: tableStyles.header.fontWeight,
          }}
        >
          <div>Accessories</div>
          <div
            style={{
              fontSize: "12px",
              fontWeight: 400,
              color: MecordColors.DefaultText,
              marginTop: "2px",
            }}
          >
            Service: {serviceLabel}
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{
          fontFamily: filterPopoverStyles.fontFamily,
          fontSize: filterPopoverStyles.fontSize,
          maxHeight: "65vh",
          overflowY: "auto",
        }}
      >
        {accessories.length > 0 ? (
          <div className="table-responsive">
            <Table
              hover
              striped
              responsive
              className="align-middle mb-0"
              style={{
                fontFamily: "Poppins, sans-serif",
                fontSize: "13px",
                border: "1px solid #dee2e6",
              }}
            >
              <thead>
                <tr style={{ 
                  backgroundColor: MecordColors.TableHeadingBGColor || "#FFF5F5", 
                  borderBottom: `2px solid ${MecordColors.ThemeBGColor || "#AB2123"}`,
                  color: MecordColors.ThemeBGColor || "#AB2123"
                }}>
                  <th
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      padding: "10px 8px",
                      textAlign: "center",
                    }}
                  >
                    #
                  </th>
                  <th
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      padding: "10px 8px",
                    }}
                  >
                    Accessory
                  </th>
                  <th
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      padding: "10px 8px",
                    }}
                  >
                    SKU
                  </th>
                  <th
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      padding: "10px 8px",
                      textAlign: "center",
                    }}
                  >
                    Qty
                  </th>
                  <th
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      padding: "10px 8px",
                      textAlign: "right",
                    }}
                  >
                    Rate
                  </th>
                  <th
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      padding: "10px 8px",
                      textAlign: "right",
                    }}
                  >
                    Discount
                  </th>
                  <th
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      padding: "10px 8px",
                      textAlign: "center",
                    }}
                  >
                    GST %
                  </th>
                  <th
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      padding: "10px 8px",
                      textAlign: "right",
                    }}
                  >
                    GST Value
                  </th>
                  <th
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      padding: "10px 8px",
                      textAlign: "right",
                    }}
                  >
                    Total
                  </th>
                  <th
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      padding: "10px 8px",
                    }}
                  >
                    Remark
                  </th>
                </tr>
              </thead>
              <tbody>
                {accessories.map((acc, index) => (
                  <tr key={acc.temp_id || index}>
                    <td style={{ padding: "10px 12px", textAlign: "center", verticalAlign: "middle" }}>
                      {index + 1}
                    </td>
                    <td
                      style={{
                        padding: "10px 12px",
                        verticalAlign: "middle",
                        maxWidth: "180px",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: 500,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        title={acc.product_name}
                      >
                        {acc.product_name}
                      </div>
                      {acc.hsn_code && (
                        <span
                          className="badge rounded-pill mt-1"
                          style={{
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "10px",
                            backgroundColor: "#fff",
                            color: MecordColors.DefaultText || "#878899",
                            border: "1px solid #ced4da",
                            fontWeight: 500,
                            display: "inline-block",
                          }}
                        >
                          HSN: {acc.hsn_code}
                        </span>
                      )}
                    </td>
                    <td
                      style={{
                        padding: "10px 12px",
                        verticalAlign: "middle",
                        fontSize: "12px",
                        color: MecordColors.DefaultText,
                      }}
                    >
                      {acc.product_sku ? (
                        <span
                          className="badge rounded-pill"
                          style={{
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "10px",
                            backgroundColor: "#fff",
                            color: MecordColors.ThemeBGColor || "#AB2123",
                            border: `1px solid ${MecordColors.SecondaryButtonBorderColor || "#AB2123"}`,
                            fontWeight: 500,
                          }}
                        >
                          {acc.product_sku}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td
                      style={{
                        padding: "10px 12px",
                        textAlign: "center",
                        verticalAlign: "middle",
                      }}
                    >
                      {acc.quantity} {acc.unit_name}
                    </td>
                    <td
                      style={{
                        padding: "10px 12px",
                        textAlign: "right",
                        verticalAlign: "middle",
                      }}
                    >
                      {currencySymbol} {formatIndianAmount(acc.unit_price)}
                    </td>
                    <td
                      style={{
                        padding: "10px 12px",
                        textAlign: "right",
                        verticalAlign: "middle",
                      }}
                    >
                      {acc.discount_value > 0 ? (
                        <>
                          {acc.discount_value}{acc.discount_type === "percentage" ? "%" : ` ${currencySymbol}`}
                          {acc.discount_type === "percentage" && acc.discount_amount > 0 && (
                            <div className="text-muted" style={{ fontSize: "11px", fontWeight: "normal" }}>
                              ({currencySymbol} {formatIndianAmount(acc.discount_amount)})
                            </div>
                          )}
                        </>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td
                      style={{
                        padding: "10px 12px",
                        textAlign: "center",
                        verticalAlign: "middle",
                      }}
                    >
                      {acc.gst_percentage}%
                    </td>
                    <td
                      style={{
                        padding: "10px 12px",
                        textAlign: "right",
                        verticalAlign: "middle",
                      }}
                    >
                      {currencySymbol} {formatIndianAmount(acc.gst_value)}
                    </td>
                    <td
                      style={{
                        padding: "10px 12px",
                        textAlign: "right",
                        verticalAlign: "middle",
                        fontWeight: 600,
                        color: MecordColors.ThemeBGColor || "#AB2123",
                      }}
                    >
                      {currencySymbol} {formatIndianAmount(acc.total_amount)}
                    </td>
                    <td
                      style={{
                        padding: "10px 12px",
                        verticalAlign: "middle",
                        maxWidth: "120px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        fontSize: "12px",
                        color: MecordColors.DefaultText,
                      }}
                      title={acc.remark}
                    >
                      {acc.remark || "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <div
            className="text-center text-muted py-4"
            style={{
              fontFamily: "Poppins, sans-serif",
              fontSize: "13px",
            }}
          >
            No accessories added for this service.
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-center">
        <Button
          variant="secondary"
          className="px-3 rounded"
          style={{
            fontFamily: filterPopoverStyles.button.fontFamily,
            fontSize: filterPopoverStyles.button.fontSize,
            borderColor: filterPopoverStyles.cancelButton.borderColor,
            color: filterPopoverStyles.cancelButton.color,
            backgroundColor: "#fff",
          }}
          onClick={onHide}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewServiceAccessoriesModal;
